// extracted by mini-css-extract-plugin
export default {"modalBody":"modal-body__pep1tjyO","title":"title__AaB88EOV","form":"form__K9MlOysw","fullWidth":"full-width__iGuGRBhT","formActions":"form-actions__jIZg9ot7"};